<template>
  <div class="portlet light portlet-fit">
    <div class="portlet-title mb-0">
      <div class="caption">
        <i class="fa fa-edit"></i>
        <span class="caption-subject bold uppercase">
          <span>Saisie des ventes pour {{ customer.customer_name }}</span>
          <span v-if="customer.customer_has_commission" class="badge badge-primary" style="font-weight: bold">Commission</span>
          <span v-if="customer.customer_has_paycomplete" class="badge badge-success bg-green-jungle" style="font-weight: bold">PayComplete</span>
        </span>
      </div>
      <div>
        <!--
        <a
          href="javascript:;"
          class="btn pull-right red ml-2"
          @click="fetchSales"
          v-if="hasChanges"
        >
          <span class="fa fa-ban"> </span> Annuler les changements
        </a>
        -->
        <a href="javascript:;" class="btn pull-right red ml-2" @click="detail()">
          Fiche du client
        </a>
        <a href="javascript:;" :class="saveButtonClasses" disabled> 
          <span v-if="saving">
            <span class="fa fa-save"> </span> Sauvegarde en cours...
          </span>
          <span v-else-if="!hasChanges && !savedAtLeastOnce">
            <span class="fa fa-clock-o"> </span> Aucun changement
          </span>
          <span v-else-if="hasChanges">
            <span class="fa fa-pencil"> </span> changements en cours... <span v-if="timeBeforeSave > 0">({{ timeBeforeSave }})</span> 
          </span>
          <span v-else-if="!hasChanges && savedAtLeastOnce">
            <span class="fa fa-check"> </span> Changements sauvegardés
          </span>
        </a>
      </div>
      <div>
        <date-picker class="pull-right mr-2" :default-date="selectedDate" :placeholder="datePickerPlaceholder" :placeholder-format="datePickerPlaceholderFormat" v-model="selectedDate"  :disabled="saving || hasChanges"></date-picker>
      </div>
      <button style="width: 50px" class="pull-right btn mr-2" :class="{'green-jungle': showDetails, 'red': !showDetails}" @click="showDetails = !showDetails;">
        <span v-if="showDetails"><i class="fa fa-check-square-o"></i></span>
        <span v-if="!showDetails"><i class="fa fa-square-o"></i></span>
      </button>
      <div class="pull-right" style="padding: 6px; color: red" v-if="hasInvalidNewValues">
        La nouvelle valeur doit être supérieure ou égale à l'ancienne valeur.
      </div>
      <div class="pull-right" style="padding: 6px; color: red" v-else-if="hasInvalidCashEval">
        Veuillez corriger les erreurs d'expression dans la case « Argent reçu »
      </div>
    </div>
    <div class="portlet-body p-0" style="overflow-x: scroll">
      <table class="table table-bordered mb-0">
        <thead>
          <tr>
            <th>Machine</th>
            <!--<th>Reset</th>-->
            <th>Ancienne valeur</th>
            <th>Nouvelle valeur</th>
            <th>Différence</th>
            <th>Moins correction</th>
            <th>Diff après correction</th>
            <th>Argent reçu</th>
            <th v-if="showDetails" style="background-color: #9acee4">Argent reçu calculé</th>
            <th v-if="showDetails" style="background-color: #9acee4">Argent reçu PayComplete</th>
            <th>Argent reçu total</th>
            <th>Diff. d'argent</th>
			      <th style="background-color: #84e680">Diff. $ cumul.</th>
            <th style="white-space: nowrap; width: 1%;">Commission (%)</th>
            <th style="white-space: nowrap; width: 1%;">Correction (%)</th>
            <th style="white-space: nowrap; width: 1%;">Commission</th>
          </tr>
        </thead>
        <tbody v-if="customer.machines !== undefined && customer.machines.length > 0">
          <tr v-for="(machine, index) in customer.machines" v-bind:key="index" :class="{'inactive': machine.machine_active == 0}">
            <td :style="machineTdStyles(machine)">
              <a @click="excelSales(machine.machine_id)"><span class="fa fa-file-excel-o"></span> </a>&nbsp;{{ machine.machine_name }}
            </td>
            <!--
            <td class="text-center" style="vertical-align: middle">
              <input type="checkbox" ref="sales_is_reset" v-model="machine.sales.sales_is_reset" @change="computeValueDifference(machine.sales)" @keypress.enter="focusNextMachine('sales_is_reset')" />
            </td>
            -->
            <td>
              <input type="number" ref="sales_value_old" class="form-control" v-model.number="machine.sales.sales_value_old" @input="computeValueDifference(machine.sales)" @keypress.enter="focusNextMachine('sales_value_old')" />
            </td>
            <td>
              <input type="number" ref="sales_value_new" class="form-control" v-model.number="machine.sales.sales_value_new" @input="computeValueDifference(machine.sales)" @keypress.enter="focusNextMachine('sales_value_new')" :class="{ is_invalid: machineOldValueIsNotValid(machine) }" />
            </td>
            <td>
              <input type="number" ref="sales_value_difference" class="form-control" v-model.number="machine.sales.sales_value_difference" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_value_difference')" />
            </td>
            <td>
              <input type="number" ref="sales_value_correction" class="form-control" v-model.number="machine.sales.sales_value_correction" @input="computeValueDifferenceAfterCorrection(machine.sales)" @keypress.enter="focusNextMachine('sales_value_correction')" />
            </td>
            <td>
              <input type="number" ref="sales_value_difference_after_correction" class="form-control" v-model.number="machine.sales.sales_value_difference_after_correction" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_value_difference_after_correction')" />
            </td>
            <td>
              <input type="text" ref="sales_cash_received_equation" class="form-control" v-model="machine.sales.sales_cash_received_equation" @input="computeCashDifference(machine.sales)" @change="formatAllToTwoDecimals" @keypress.enter="focusNextMachine('sales_cash_received_equation')" :class="{ is_invalid: machine.sales.eval_has_errors }"  />
            </td>
            <td v-if="showDetails">
              <input type="number" ref="sales_cash_received_calculated" class="form-control" v-model.number="machine.sales.sales_cash_received_calculated" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_cash_received_calculated')" style="background-color: #c5e5f3" />
            </td>
            <td v-if="showDetails">
              <input type="number" ref="sales_cash_received_paycomplete_report" class="form-control" v-model.number="machine.sales.sales_cash_received_paycomplete_report" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_cash_received_paycomplete_report')" style="background-color: #c5e5f3" />
            </td>
            <td>
              <input type="number" ref="sales_cash_received_total" class="form-control" v-model.number="machine.sales.sales_cash_received_total" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_cash_received_total')" />
            </td>
            <td>
              <input type="number" ref="sales_cash_difference" class="form-control" v-model.number="machine.sales.sales_cash_difference" readonly tabindex="-1" @keypress.enter="focusNextMachine('sales_cash_difference')" />
            </td>
            <td>
              <input type="number" ref="machine_cash_difference_cumulative" class="form-control" :value="machineCashCumulativeDifference(machine)" readonly tabindex="-1" @keypress.enter="focusNextMachine('machine_cash_difference_cumulative')" style="background-color: #c7f3c5" />
            </td>
            <td>
              <input type="number" ref="sales_commission_percent" class="form-control" v-model.number="machine.sales.sales_commission_percent" @input="computeCommission(machine.sales)" @keypress.enter="focusNextMachine('sales_commission_percent')" />
            </td>
            <td>
              <input type="number" ref="sales_correction_percent" class="form-control" v-model.number="machine.sales.sales_correction_percent" @input="computeCommission(machine.sales)" @keypress.enter="focusNextMachine('sales_correction_percent')" />
            </td>
            <td>
              <input type="number" ref="sales_commission" class="form-control" v-model.number="machine.sales.sales_commission" readonly tabindex="-1" step="0.01" @keypress.enter="focusNextMachine('sales_commission')" />
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <td colspan="11" class="text-center p-2">
            Ce client n'a aucune machine.
          </td>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    defaultDate: {
      type: String,
      required: true,
    },
    defaultCustomerId: {
      type: Number,
      required: true,
    },
    datePickerPlaceholder: {
      type: String,
      required: true,
    },
    datePickerPlaceholderFormat: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedDate: this.defaultDate,
      selectedCustomerId: this.defaultCustomerId,
      customer: {},
      hasChanges: false,
      savedAtLeastOnce: false,
      saving: false,
      timeBeforeSave: -1,
      focusedInput: null,
      showDetails: false
    };
  },
  computed: {
    salesEndpoint() {
      return `${baseUrl}customer/salesgrid/retrieveone?date=${this.selectedDate}&customer=${this.selectedCustomerId}`;
    },
    saveEndpoint() {
      return `${baseUrl}customer/salesgrid/savecustomer`;
    },
    excelEndpoint() {
      return `${baseUrl}sales/excel/token/excel_sales`;
    },
    excelReadyEndpoint() {
      return `${baseUrl}sales/excel/checkifready`;
    },
    hasInvalidNewValues() {
      if (this.customer.machines === undefined) return false;
      for (const machine of this.customer.machines) {
        if ((machine.sales.sales_value_new < machine.sales.sales_value_old && !machine.sales.sales_is_reset) && machine.will_save) {
          this.timeBeforeSave = -1;
          return true;
        }
      }
      if(this.hasChanges){
        this.timeBeforeSave = 2;
      }
      return false;
    },
    hasInvalidCashEval() {
      if (this.customer.machines === undefined) return false;
      for (const machine of this.customer.machines) {
        if (machine.sales.eval_has_errors) {
          this.timeBeforeSave = -1;
          return true;
        }
      }
      if(this.hasChanges){
        this.timeBeforeSave = 2;
      }
      return false;
    },
    hasInvalidFields() {
      return this.hasInvalidNewValues || this.hasInvalidCashEval;
    },
    machineTdStyles() {
      return (machine) => {
        return {
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          padding: "0 3px",
          color: machine.will_save ? "#000" : "#777",
        };
      };
    },
    saveButtonClasses() {
      return [
        'btn', 
        'pull-right', 
        { 'purple' : !this.hasChanges && !this.savedAtLeastOnce },
        { 'blue' : this.hasChanges },
        { 'green-jungle' : !this.hasChanges && this.savedAtLeastOnce }
      ]
    },
    machineCashCumulativeDifference(){
      return (machine) => {
        let current_diff = parseFloat(machine.sales.sales_cash_difference);
        let cumul = parseFloat(machine.machine_cash_difference_cumulative);
        if(!isNaN(current_diff)){
          cumul += current_diff;
        }
        return cumul.toFixed(2);
      }
    },
    machineOldValueIsNotValid(){
      return (machine) => {
        return (machine.sales.sales_value_new < machine.sales.sales_value_old && !machine.sales.sales_is_reset) && machine.will_save;
      }
    }
  },
  watch: {
    async selectedDate() {
      await this.fetchSales();
    },
    customer: {
      handler(){
        if(this.timeBeforeSave > 0){
          this.timeBeforeSave = 2;
        }
      },
      deep: true
    },
    async hasChanges() {
      this.$emit("change");
    }
  },
  mounted() {
    let _this = this;
    this.fetchSales();
    this.defaultpay();
    setInterval(() => {
      _this.timeBeforeSave--;
      if(_this.timeBeforeSave == 0){
        _this.saveChanges();
      }
    }, 1000); 
  },
  methods: {
    async defaultpay(){
        let customer = await $.ajax({
          url: this.salesEndpoint,
          method: "GET",
          dataType: "JSON",
        });
        
        this.$nextTick(()=>{
          if(customer.customer_has_paycomplete)
          {
            this.showDetails = true
          }
        })
    },
    detail(){
      window.location.href = `${window.baseUrl}/customer/view/`+this.defaultCustomerId
    },
    async excelSales(id){
      var message_text = "<h1>" + L('GENERATION') + "...<br>" + L('PLEASE_WAIT') + "</h1>";
      App.blockUI({ message: message_text ,boxed: true, zIndex: 20000  });
      var token = "excel_sales";
      window.location = this.excelEndpoint+'?machine_id='+id;
      this.checkIfReportSalesReady(token,0);
    },
    async checkIfReportSalesReady(token,counter){
      var limit = 120;
      if (counter < limit) {

        let data = {
          token: token,
        };

        let result = await $.ajax({
          url: this.excelReadyEndpoint,
          data: data,
          method: "POST",
          dataType: "JSON",
        });

        if(result.result==1){
          App.unblockUI();
        }
        else{
          let that = this;
          setTimeout(function(){ that.checkIfReportSalesReady(token,counter + 1); }, 1000);
        }

      }
      else{
        toastr.error(L('ERROR_MESSAGE'), L('ERROR'));
        App.unblockUI();
      }
    },
    async fetchSales() {
      let _this = this;

      try {
        let data = await $.ajax({
          url: this.salesEndpoint,
          method: "GET",
          dataType: "JSON",
        });

        let customer = data;

        for (const machine of customer.machines) {
          if (machine.sales === false) {
            machine.sales = {
              sales_commission_percent: machine.machine_commission,
              sales_correction_percent: machine.machine_sales_correction,
              sales_value_old: machine.machine_default_old_value,
              sales_value_correction: 0,
              sales_value_new: "",
              sales_cash_received_equation: "",
              sales_cash_received_calculated: 0,
              sales_cash_received_paycomplete_report: 0,
              sales_cash_received_total: 0,
              eval_has_errors: false,
            };
            machine.will_save = false;
          } else {
            machine.sales.sales_value_difference_after_correction = machine.sales.sales_value_difference - machine.sales.sales_value_correction;
            machine.sales.eval_has_errors = false;
            machine.machine_cash_difference_cumulative -= machine.sales.sales_cash_difference;
          }

        }

        this.hasChanges = false;
        this.customer = customer;
        this.formatAllToTwoDecimals();
        this.refreshWillSave();
        setTimeout(() => {
          for (const ref of _this.$refs["sales_value_new"]) {
            if(!ref.parentNode.parentNode.classList.contains("inactive")) {
              ref.focus();
              break;
            }
          }
        }, 50);
      } catch (err) {
        console.error(err);
        toastr.error("Erreur lors de l'acquisition des données de ventes.");
      }
    },
    async saveChanges() {
      if (this.hasInvalidFields) {
        return;
      }

      this.saving = true;

      let data = {
        date: this.selectedDate,
        customer_id: this.selectedCustomerId,
        machines: this.customer.machines,
      };

      try {
        await $.ajax({
          url: this.saveEndpoint,
          method: "POST",
          dataType: "JSON",
          data: data,
        });
        this.saving = false;
        this.hasChanges = false;
        this.savedAtLeastOnce = true;
        toastr.success("Données de ventes sauvegardées avec succès.");
      } catch (err) {
        console.error(err);
        this.saving = false;
        toastr.error("Erreur lors de la sauvegarde des données de ventes.");
      }
    },
    computeValueDifference(sales) {
      if(sales.sales_is_reset){
        sales.sales_value_difference = sales.sales_value_new;
      } else {
        sales.sales_value_difference = sales.sales_value_new - sales.sales_value_old;
      }
      this.computeValueDifferenceAfterCorrection(sales);
    },
    computeValueDifferenceAfterCorrection(sales) {
      sales.sales_value_difference_after_correction = sales.sales_value_difference - sales.sales_value_correction;
      this.computeCashDifference(sales);
    },
    formatAllToTwoDecimals(){
      for (const machine of this.customer.machines) {
        let sales = machine.sales;
        sales.sales_cash_difference = parseFloat(sales.sales_cash_difference).toFixed(2);
        sales.sales_cash_received_calculated = parseFloat(sales.sales_cash_received_calculated).toFixed(2);
        sales.sales_cash_received_paycomplete_report = parseFloat(sales.sales_cash_received_paycomplete_report).toFixed(2);
        sales.sales_cash_received_total = parseFloat(sales.sales_cash_received_total).toFixed(2);
      }
    },
    computeCashDifference(sales) {
      try {
        sales.sales_cash_received_equation = (sales.sales_cash_received_equation+"").replace(/[^0-9\.\+\-\*\/]/g, "");
        sales.sales_cash_received_calculated = eval(sales.sales_cash_received_equation);
        sales.sales_cash_received_total = parseFloat(sales.sales_cash_received_calculated) + parseFloat(sales.sales_cash_received_paycomplete_report);
        sales.sales_cash_difference = (sales.sales_cash_received_total - sales.sales_value_difference_after_correction).toFixed(2);
        sales.eval_has_errors = false;
        this.computeCommission(sales);
      } catch {
        sales.eval_has_errors = true;
      }
    },
    computeCommission(sales) {
      let to_subtract = sales.sales_cash_received_total * (sales.sales_correction_percent / 100);
      let corrected_cash_received = sales.sales_cash_received_total - to_subtract;
      sales.sales_commission = ( (sales.sales_commission_percent / 100) * corrected_cash_received ).toFixed(2);
      this.hasChanges = true;
      this.refreshWillSave();
    },
    refreshWillSave() {
      for (const machine of this.customer.machines) {
        machine.will_save = machine.sales.sales_value_new !== "";
      }
    },
    focusNextMachine(field) {
      let selectedIx = this.$refs[field].findIndex(e => {
        return e == document.activeElement;
      })

      let nextIx = selectedIx+1;
      while(this.customer.machines[nextIx] != undefined && this.customer.machines[nextIx].machine_active == 0) {
        nextIx++;
      }

      let nextElement = this.$refs[field][nextIx];

      //console.log(field,nextElement);

      if(nextElement === undefined){
        let firstIx = 0;
        while(this.customer.machines[firstIx] != undefined && this.customer.machines[firstIx].machine_active == 0) {
          firstIx++;
        }

        if(field == "sales_value_new"){
          nextElement = this.$refs["sales_cash_received_equation"][firstIx];
        } else if(field == "sales_cash_received_equation"){
          this.saveChanges();
          nextElement = document.querySelectorAll(".header-typeahead")[1];
        } else {
          nextElement = this.$refs[field][firstIx];
        }
      }

      nextElement.focus();
    }
  },
};
</script>

<style lang="scss" scoped>
.form-control {
  font-size: 14px;
  padding: 4px 8px;
  height: 26px;
}

.table td,
.table th {
  padding: 0;
}

.table th {
  padding: 3px;
}

.table input {
  border-radius: 0;
  border: none;
}

.is_invalid {
  background-color: rgb(255, 176, 176);
}

.will-not-save {
  background-color: #fdd;
}
.cash_diffrence_cummul{
	display:none;
}

table tr.inactive {
  display: none;
}
</style>
